import { coerceBooleanProperty } from '@angular/cdk/coercion';

export function coerceBoolean() {
	return function (target: any, key: string): void {
		const getter = function () {
			// using Typescript reflection
			return this['__' + key];
		};

		const setter = function (next: any) {
			// using Typescript reflection
			this['__' + key] = coerceBooleanProperty(next);
		};

		Object.defineProperty(target, key, {
			get: getter,
			set: setter,
			enumerable: true,
			configurable: true
		});
	};
}
